export default __webpack_public_path__ + "ab700a96a6bb24869098f965cd027441.jpg";